import { ChannelTypeInternal, MeterTypeInternal } from '../../../../data-access/gql-types/graphql';
import { useDevicesAndChannelsContext } from '../../context/devices-and-channels';

export const usePriceConditionSupported = () => {
  const { channelList } = useDevicesAndChannelsContext();

  const priceConditionSupportedChannels = channelList.filter(
    (x) =>
      (x.data.type === ChannelTypeInternal.Meter && x.data.meterType === MeterTypeInternal.Standalone) ||
      (x.data.type === ChannelTypeInternal.Meter && x.data.meterType === MeterTypeInternal.BudgetPlug) ||
      x.data.type === ChannelTypeInternal.Optimizer,
  );

  return {
    priceConditionSupported: priceConditionSupportedChannels.length,
  };
};
